window.$s = window.$s || new function() {
  var html = document.querySelector('html');
  this.showLoadingOverlay = function() {
    html.classList.add('show-loading-overlay');
  },
  this.hideLoadingOverlay = function() {
    html.classList.remove('show-loading-overlay');
  }
}
$s.AutoAddRemoveProducts = new function() {
  var debugOutput = !!(new URL(location.href).searchParams.get('debug'));
  function debug() {
    if (debugOutput) {
      /* validation-disable:checkConsoleDebug */
      console.debug.apply(this, arguments);
      /* validation-enable:checkConsoleDebug */
    }
  }
  const CacheOutOfStock = new function() {
    const storage = sessionStorage;
    const storageKey = 'auto_addons_out_of_stock_variants';
    function getVariants() {
      const expireSeconds = 3600;
      let data = JSON.parse(storage.getItem(storageKey) || '{}');
      if (!data.update_ts || data.update_ts + expireSeconds*1000 < new Date().getTime()) {
        data = {update_ts: new Date().getTime()};
      }
      return data;
    }
    this.filterOutOfStock = async function(variants, variantsRequiredQuantities) {
      const data = getVariants();
      const variantsToCheck = variants.filter(id=>!data[id]);
      const ret = {};
      const requests = [];
      const newOutOfStock = [];
      variantsToCheck.forEach(id=>{
        const request = $s.get({url:'/variants/'+id+'?section_id=variant_info'}).then(data=>{
          const info = JSON.parse(data.substring(data.indexOf('>')+1, data.lastIndexOf('</')));
          if (info.available && (info.inventory_policy=='continue' || variantsRequiredQuantities[id] <= info.inventory_quantity)) {
            ret[id] = 1;
          } else {
            newOutOfStock.push(id);
          }
        });

        requests.push(request);
      });
      await Promise.all(requests);
      if (newOutOfStock.length > 0) {
        const newData = getVariants();
        newOutOfStock.forEach(id=>{newData[id] = 1});
        storage.setItem(storageKey, JSON.stringify(newData));
      }

      return ret;
    }
    
  }
  
  //standalone post method
  function postUpdate(url, data) {
    var headers = {}
    if (!(data instanceof FormData || typeof data==='string')) {
      headers["Content-Type"] = "application/json";
    }
    return fetch(url, {
      "method": "POST",
      "body": (data instanceof FormData || typeof data==='string' ? data : JSON.stringify(data)),
      "headers": headers
    }).then(res => res.json())
  }

  var autoAddRemoveProductsRules = [];
  function createSettings(promoName, allowedItems = [], autoRemove = true, maxUses = 1) {
    var allowedItems = allowedItems||[];
    allowedItems.forEach(x=> {
      if (!x.properties) x.properties = {};
      x.properties._gwp_promo_id = promoName;
    });
    return {"promoName": promoName, "allowedItems": allowedItems, "autoRemove": autoRemove, "maxUses": maxUses };
  }
  function getGwpDiscountCodes(cart) {
    let codes = cart.discount_codes ? cart.discount_codes.map(x=>x.code) : [];
    codes.push(...cart.discount_codes_applicable || []);
    return codes.filter(Boolean).map(x=>String(x).toLowerCase());
  }
  function createConditionRequiredDiscountCode(discountCode) {
    var condition = createConditionCustom(function(cart) {
      // cart.discount_codes is from cart.js and cart.discount_codes_applicable is from Liquid.
      let codes = getGwpDiscountCodes(cart);
      return codes.includes(discountCode.toLowerCase());
    });
    return condition;
  }
  function itemMatch(item, query) { //recursive function
    var equal = !!item;
    for (var p in query) {
      if (!equal)
        return false;
      var type = typeof(query[p]);
      if (type=='object') {
        equal = equal && itemMatch(item[p], query[p]);
      } else if(type=='array') {
        for (var i=0; equal && i<item[p].length; i++) {
          equal = equal && item[p][i]===query[p][i];
        }
      } else {
        equal = equal && item[p]===query[p];
      }
    }
    return equal;
  }
  function findItems(cart, itemQuery) {
    var items = cart.items.filter(function(item) {
        return itemMatch(item, itemQuery);
      });
    return items;
  }
  function createCartFilter(itemQueries) {
    return function(cart, promoName) {
      var newCart = Object.assign({}, cart);
      if ($s.AutoAddRemoveProductsCart.itemsToExclude[promoName]) {
        newCart.items = newCart.items.filter(item=>{
          var ok = (item.properties && item.properties._gwp_promo_id == promoName)
            || $s.AutoAddRemoveProductsCart.itemsToExclude[this.settings.promoName].indexOf(item.id) == -1;
          return ok;
        });
      }
      if (itemQueries.length > 0) {
        newCart.items = newCart.items.filter(item=>{
          if (item.properties && item.properties._gwp_promo_id == promoName) {
            return true;
          }

          for (var i=0; i<itemQueries.length; i++) {
            if (itemMatch(item, itemQueries[i])) {
              return true;
            }
          }
          return false;
        });
      }
      return newCart;
    }
  }
  function createConditionMinAmount(amount) { //amount is configured in shop currency
    var thresholdCents = gwpResolvePresentmentThresholdCents(amount);
    var condition = createConditionCustom(function(cart) {
      if (thresholdCents === null) {
        cart.__gwpMonetaryContextUnresolved = true;
        return false;
      }
      var total = 0;
      var useBefore = window.__gwpPromotionsConfig && window.__gwpPromotionsConfig.compareAmountMode === 'before';
      cart.items.forEach((item)=>{
        if (!item.properties || !item.properties._gwp_promo_id) {
          total += useBefore ? item.original_line_price : item.final_line_price;
        }
      });
      if (thresholdCents > 0) {
        var times = Math.floor(total / thresholdCents);
        cart.passedTimes = cart.passedTimes==-1 ? times : Math.min(cart.passedTimes, times);
      }
      return total >= thresholdCents;
    });
    return condition;
  }
  function createConditionMaxAmount(amount) { //amount is configured in shop currency
    var thresholdCents = gwpResolvePresentmentThresholdCents(amount);
    var condition = createConditionCustom(function(cart) {
      if (thresholdCents === null) {
        cart.__gwpMonetaryContextUnresolved = true;
        return false;
      }
      var total = 0;
      var useBefore = window.__gwpPromotionsConfig && window.__gwpPromotionsConfig.compareAmountMode === 'before';
      cart.items.forEach((item)=>{
        if (!item.properties || !item.properties._gwp_promo_id) {
          total += useBefore ? item.original_line_price : item.final_line_price;
        }
      });

      var times = total < thresholdCents ? 1 : 0;
      cart.passedTimes = cart.passedTimes==-1 ? times : Math.min(cart.passedTimes, times);

      return total < thresholdCents;
    });
    return condition;
  }
  function createConditionMinQuantity(minQuantity) { //min quantity of products to pass the requirements
    var condition = createConditionCustom(function(cart) {
      var total = 0;
      cart.items.forEach((item)=>{
        if (!item.properties || !item.properties._gwp_promo_id) {
          total += item.quantity
        }
      });
      if (minQuantity>0) {
        var times = Math.floor(total/minQuantity);
        cart.passedTimes = cart.passedTimes==-1 ? times : Math.min(cart.passedTimes, times);
      }
      return (total >= minQuantity);
    });
    return condition;
  }

  function calcPassedUses(passedTimes, settings) {
    var uses = settings.maxUses ? settings.maxUses : passedTimes; //if not maxUses, then there is no limit;
    return (passedTimes>1 ? Math.min(uses, passedTimes) : 1);
  }
  
  //recommended to validate the quantity of promo items in cart, you should include filter "properties: {_gwp_promo_id: promoName}"
  function createConditionMaxQuantity(itemQuery, maxQuantity) {  //object with line_item attributes. | integer
    var condition = createConditionCustom(function(cart, settings) {
      var itemsPromo = findItems(cart, itemQuery);
      var total = 0;
      itemsPromo.forEach(item=>{total += item.quantity});
      var uses = calcPassedUses(cart.passedTimes, settings);
      if (uses>1) {
        return total <= maxQuantity * uses;
      }
      return total<=maxQuantity;
    });
    return condition;
  }
  function createConditionCustom(conditionLogic) {
    var condition = new function() {
      this.logic = conditionLogic;
    }
    return condition;
  }
  function createActionAllowGWP() {
    var action = createActionCustom(function(rule, settings, cart, requirementsPassed) {
      if (cart.__gwpMonetaryContextUnresolved) {
        debug('AutoAddons: monetary context unresolved; preserve managed GWP items');
        return;
      }
      var itemsPromo = cart.items.filter(function(item) {
        return item.properties && item.properties._gwp_promo_id === settings.promoName;
      });
      if (requirementsPassed) {
        debug('AutoAddons: requirements passed');
        settings.allowedItems.forEach(function(item) {
          cart.passedUses = calcPassedUses(cart.passedTimes, settings); //if not maxUses, then there is no limit;
          item.quantity = item.maxQuantity * cart.passedUses;

          var matchingItemsPromo;
          if (item.one_by_product) {
            matchingItemsPromo = itemsPromo.filter(i=>i.product_id==item.product_id);
          } else {
            matchingItemsPromo = itemsPromo.filter(i=>i.id==item.id);
          }
          var itemExist = matchingItemsPromo[0];

          if (!itemExist) {
            if (item.autoAdd) {
              if (item.one_by_product) {
                var existingItem = itemsPromo.find(i=>i.product_id==item.product_id);
                if (!existingItem) {
                  const variantOptions = (item.variantIds || settings.allowedItems.filter(x=>x.product_id==item.product_id).map(x=>x.id))
                    .map(function(id) { return 'gid://shopify/ProductVariant/'+id; });
                  item.properties['_edit_options'] = JSON.stringify({v:variantOptions});
                  rule.cartOut.addItems.push(item);
                  debug('AutoAddons: add One By Product', item);
                }
              } else {
                rule.cartOut.addItems.push(item);
                debug('AutoAddons: add', item);
              }
            } else {
              rule.cartOut.allowItems.push(item);
              debug('AutoAddons: no action because autoAdd is false', item);
            }
          } else {
            if (item.quantity != itemExist.quantity) {
              itemExist = Object.assign({}, itemExist); //copy to not modify the source
              if (item.autoAdd || item.quantity < itemExist.quantity) {
                itemExist.quantity = item.quantity;
                rule.cartOut.updateItems.push(itemExist);
                debug('AutoAddons: update item quantity');
              } else {
                itemExist.quantity = item.quantity - itemExist.quantity; //quantity allowed to increase;
                rule.cartOut.allowItems.push(itemExist);
                debug('AutoAddons: allow item:', item, '\nno update because item.autoAdd=' + (item.autoAdd?'true':'false') + ', item.quantity=' + item.quantity + ', itemExist.quantity=' + itemExist.quantity);
              }
            } else {
              debug('AutoAddons: no action, item already in cart');                
            }

            if (item.autoAdd && matchingItemsPromo.length > 1) {
              matchingItemsPromo.slice(1).forEach(function(surplusItem) {
                var surplusItemCopy = Object.assign({}, surplusItem);
                surplusItemCopy.quantity = 0;
                rule.cartOut.updateItems.push(surplusItemCopy);
              });
              debug('AutoAddons: remove surplus promo-managed GWP items', matchingItemsPromo.slice(1));
            }
          }
        })
      } else {
        debug('AutoAddons: requirements not passed');
        if (itemsPromo.length>0) {
          if (settings.autoRemove) {
            itemsPromo.forEach(x=>x.quantity = 0);
            rule.cartOut.updateItems = itemsPromo;
            debug('AutoAddons: remove', itemsPromo);
          } else {
            debug('AutoAddons: autoremove=false, invalid item remains in cart');
          }
        } else {
          debug('AutoAddons: no action, item not in cart');
        }
      }
    });
    return action;
  }
  function createActionCustom(actionLogic) { //actionLogic is a function with parameters: rule, settings, cart, requirementsPassed
    var action = new function() {
      this.logic = actionLogic;
    }
    return action;
  }
  class Rule extends EventTarget {
    constructor(settings, requiredConditions, action, cartFilter) {
      super();
      this.settings = settings;
      this.requiredConditions = requiredConditions;
      this.action = action;
      this.cartOut = null;
      this.cartFilter = cartFilter;
      this.run = (cart) => {
        this.cartOut = {addItems: [], updateItems: [], allowItems: []};
        var cartForConditions = this.cartFilter(cart, this.settings.promoName);
        cartForConditions.__gwpConditionItems = cart.items.filter(function(item) {
          return !(item.properties && item.properties._gwp_promo_id);
        });
        cartForConditions.passedTimes = -1;
        cartForConditions.__gwpMonetaryContextUnresolved = false;
        var passed = validateConditions(cartForConditions, this.requiredConditions, this.settings);
        cart.passedTimes = cartForConditions.passedTimes;
        cart.__gwpMonetaryContextUnresolved = cartForConditions.__gwpMonetaryContextUnresolved;
        this.action.logic(this, this.settings, cart, passed);
        this.dispatchEvent(new CustomEvent('run', {detail: {rule: this, passed}}));

        return passed;
      }
      this.start = ()=> {
        if (autoAddRemoveProductsRules.indexOf(this)==-1) {
          autoAddRemoveProductsRules.push(this);
        }
      }
      this.stop = ()=> {
        var index = autoAddRemoveProductsRules.indexOf(this);
        if (index>-1) {
          autoAddRemoveProductsRules.splice(index, 1);
        }
      }
      this.start();
    }
  }
  function createRule(settings, requiredConditions, action, cartFilter)  {
    var rule = new Rule(settings, requiredConditions, action, cartFilter);
    return rule;
  }
  function validateConditions(cart, conditions, settings) { //returns true if all conditions are met, otherwise return false
    return !conditions.find(c=>{var r = !c.logic(cart, settings); if (r){debug('AutoAddons: condition not passed', c.logic)}; return r;});
  }
  function getRules() {
    return autoAddRemoveProductsRules;
  }
  function runAllRules(cart, updateCart=true) {
    var cartOut = {addItems: [], updateItems: [], allowItems: []};
    var validPromos = [];
    var promise = new Promise(async (resolve, reject)=> {

      if (window.Shopify && Shopify.designMode) {
        resolve({validPromos: validPromos, modified: false});
        return;
      }

      for (var i=0; i<autoAddRemoveProductsRules.length; i++) {
        var rule = autoAddRemoveProductsRules[i];
        var cartCopy = JSON.parse(JSON.stringify(cart));
        if (rule.run(cartCopy)) {
          validPromos.push({promoName: rule.settings.promoName, rule: rule, cart: cartCopy});
        }
        rule.cartOut.addItems.forEach(x=>cartOut.addItems.push(x));
        rule.cartOut.updateItems.forEach(x=>cartOut.updateItems.push(x));
        rule.cartOut.allowItems.forEach(x=>cartOut.allowItems.push(x));
      };

      //remove items from promotions not available, or invalid promo items
      cart.items.forEach(function(item) {
        var promoKey = item.properties && item.properties['_gwp_promo_id'];
        if (promoKey) {
          var rule = autoAddRemoveProductsRules.find(rule=>rule.settings.promoName==promoKey);
          if (!rule) {
            const itemCopy = JSON.parse(JSON.stringify(item));
            itemCopy.quantity = 0;
            cartOut.updateItems.push(itemCopy);
          } else {
            var allowedItem = rule.settings.allowedItems.find(x=>x.id==item.id);
            var allowedByVariantIds = rule.settings.allowedItems.some(function(ai) {
              return ai.variantIds && ai.variantIds.indexOf(item.id) !== -1;
            });
            if (!allowedItem && !allowedByVariantIds) {
              const itemCopy = JSON.parse(JSON.stringify(item));
              itemCopy.quantity = 0;
              cartOut.updateItems.push(itemCopy);
            }
          }
        }
      });

      async function handleError(msg, payload) {
        console.error('Couldn\'t update cart: ', msg, payload);
        var clearResponse = fetch(routes.cart_url + '/clear.json');
        msg += (msg ? '\n\n': '') + lngg.cart__auto_addons_js__error_clear_cart_message;
        alert(msg);
        await clearResponse;
      }

      if (updateCart) {
        var modified = false;
        if (cartOut.updateItems.length > 0 || cartOut.addItems.length > 0) {
          //calculate new total quantity per variant
          //validate those that increase their quantity
          const totalVariantQuantities = {}
          var cartItemsNewQuantity = JSON.parse(JSON.stringify(cart));
          var variantsToValidate = [];

          cartOut.updateItems.forEach(x=>{
            const cartItem = cartItemsNewQuantity.items.find(item=>item.key==x.key);
            if (cartItem) {
              if (cartItem.quantity < x.quantity && variantsToValidate.indexOf(x.id)==-1) {
                variantsToValidate.push(x.id);
              }
              cartItem.quantity = x.quantity;
            }
          });
          cartOut.addItems.forEach(x=>{
            if (variantsToValidate.indexOf(x.id)==-1) {
              variantsToValidate.push(x.id);
            }
            cartItemsNewQuantity.items.push({id: x.id, quantity: x.quantity});
          });
          cartItemsNewQuantity.items.forEach(item=>{
            totalVariantQuantities[item.id] = (totalVariantQuantities[item.id] || 0) + item.quantity;
          });

          //return variants that have enough stock satisfy cart needs
          var inStockVariants = await CacheOutOfStock.filterOutOfStock(variantsToValidate, totalVariantQuantities);

          if (cartOut.updateItems.length > 0) {
            var inStockItems = cartOut.updateItems.filter(x=>{return inStockVariants[x.id] || x.quantity < cart.items.find(item=>item.key==x.key).quantity});
            if (inStockItems.length > 0) {
              var items = {}
              $s.showLoadingOverlay();
              inStockItems.forEach(x=>{items[x.key] = x.quantity});
              var data = {updates: items};
              var newCart = await $s.updateCartItemsQuantity(data)
              modified = true;
              $s.hideLoadingOverlay();
            }
          }
          if (cartOut.addItems.length > 0) {
            var inStockItems = cartOut.addItems.filter(x=>{return inStockVariants[x.id]});
            var items = [];
            inStockItems.forEach(item=>{
              if (!item.one_by_product || !items.find(x=>x.product_id==item.product_id)) {
                items.push(item);
              }
            })
            
            if (items.length>0) {
              $s.showLoadingOverlay();
              var newItem = await postUpdate(routes.cart_url + '/add.js', {items: items});
              if (newItem.status) {
                await handleError(newItem.description, items);
              }
              modified = true;
              $s.hideLoadingOverlay();
            }
          }
        }
        resolve({validPromos: validPromos, modified: modified});
      } else {
        resolve({validPromos: validPromos, modified: false});
      }

    });
    return promise;
  }
  return {
    createSettings: createSettings,
    createConditionRequiredDiscountCode: createConditionRequiredDiscountCode,
    createConditionMinAmount: createConditionMinAmount,
    createConditionMaxAmount: createConditionMaxAmount,
    createConditionMinQuantity: createConditionMinQuantity,
    createConditionMaxQuantity: createConditionMaxQuantity,
    createConditionCustom: createConditionCustom,
    createCartFilter: createCartFilter,
    createActionAllowGWP: createActionAllowGWP,
    createActionCustom: createActionCustom,
    validateConditions: validateConditions,
    createRule: createRule,
    getRules: getRules,
    runAllRules: runAllRules,
    postUpdate: postUpdate,
  }
}
$s.AutoAddRemoveProductsCart = {itemsToExclude: {} };

// Fetch product tags for cart items not yet in __cartItemTags cache.
// Called before runAllRules to ensure excluded-tag filtering works on AJAX updates.
$s.refreshCartItemTags = async function(cart) {
  var tagCache = window.__cartItemTags || {};
  var seenHandles = {};
  var promises = [];
  (cart.items || []).forEach(function(item) {
    if (item.handle && !tagCache[item.id] && !seenHandles[item.handle]) {
      seenHandles[item.handle] = true;
      promises.push(
        fetch('/products/' + item.handle + '.json')
          .then(function(r) { return r.json(); })
          .then(function(data) {
            var productTags = (data.product.tags || '').split(', ').filter(Boolean);
            (data.product.variants || []).forEach(function(v) {
              tagCache[v.id] = productTags;
            });
          })
          .catch(function() {})
      );
    }
  });
  if (promises.length > 0) await Promise.all(promises);
  window.__cartItemTags = tagCache;
};

window.FreeSamples = new function () {
  this.initSections = function(validPromos) {
    validPromos.forEach(function(promo) {
      var section = document.querySelector('.free-samples-selector[data-promo="'+promo.promoName+'"]');
      if (section) {
        section.style.display = 'block';
        const cartPromoitems = promo.cart.items.filter(x=>x.properties && x.properties['_gwp_promo_id']==promo.promoName)
        var allowedQuantity = section.dataset.maxItems * promo.cart.passedUses;

        var selectedQuantity = 0;
        cartPromoitems.forEach((item)=>{selectedQuantity += item.quantity/1;});

        section.querySelectorAll('.section-title .allowed, .section-text .allowed').forEach((elem)=> {
          elem.innerHTML = allowedQuantity;
        });
        section.querySelectorAll('.section-title .selected, .section-text .selected').forEach((elem)=> {
          elem.innerHTML = selectedQuantity;
        });
        section.querySelectorAll('.section-title.single, .section-text.single').forEach((elem)=> {
          elem.style.display = allowedQuantity==1 ? '' : 'none';
        });
        section.querySelectorAll('.section-title.multiple, .section-text.multiple').forEach((elem)=> {
          elem.style.display = allowedQuantity>1 ? '' : 'none';
        });

        var disabled = selectedQuantity >= allowedQuantity;

        const samples = section.querySelectorAll('.item-sample');
        samples.forEach(function(sample) {
          sample.allowedItems = promo.rule.cartOut.allowItems.filter(x=>x.product_id==sample.dataset.productId);
          sample.cartItems = cartPromoitems.filter(x=>x.product_id==sample.dataset.productId);
          sample.addDisabled = disabled;
          sample.settings = promo.rule.settings;
          sample.updateForm();
        });


        var carousel = section.querySelector('component-carousel')
        if (carousel.initSlider) {
          carousel.initSlider();
        } else {
          carousel.setAttribute('data-init-ondemand', 'false');
        }
      }
    });    
  }

}

class ComponentFreeSampleCard extends HTMLElement {
  constructor() {
    super()
    var self = this;
    self.section = this.closest('.free-samples-selector');
    self.util = $s.AutoAddRemoveProducts;
    self.remove = this.querySelector('.remove-sample');
    self.update = this.querySelector('.quantity-input');
    self.add = this.querySelector('.add');
    self.variantSelector = this.querySelector('[name="id"]');
    self.allowedItems = [];
    self.cartItems = [];
    self.addDisabled = true;
    self.settings = null;
    self.updateForm = function() {
      const variantId = self.variantSelector.value;
      const allowedItem = self.allowedItems.find(item=>item.id==variantId);
      const cartItem = self.cartItems.find(item=>item.id==variantId);
      self.setAttribute('data-edit', 'none');
      if (!cartItem) {
        if (allowedItem) {
          self.setAttribute('data-edit', 'add');
        }
      } else {
        self.dataset.key = cartItem.key;
        self.querySelector('.quantity-input').value = cartItem.quantity;
        if (allowedItem) {
          self.setAttribute('data-edit', 'add-quantity');
        } else if (cartItem.quantity>1) {
          self.setAttribute('data-edit', 'remove-quantity');
        } else {
          self.setAttribute('data-edit', 'remove');
        }
      }
      
      self.querySelectorAll('.add, .quantity-button.plus').forEach(function(btn) {
        if (self.addDisabled) {
          btn.setAttribute('disabled', true);
        } else {
          btn.removeAttribute('disabled');
        }
      });

    }
    self.variantSelector.addEventListener('change', self.updateForm);
    self.updateForm();

    async function updateUI() {
      var sectionCart = window.SideCart ? 'side_cart' : 'cart_content';
      $s.getJson({url: routes.root_url + '?sections='+sectionCart, success: async function(data){
        $s.hideLoadingOverlay();
        if (window.SideCart) {
          window.SideCart.openAfterUpdate = true;
        }
        var parser = new DOMParser();
        var doc = parser.parseFromString(data[sectionCart], "text/html");
        var addonsJs = doc.querySelector('#cart-addons');
        var itemsManagementJs = doc.querySelector('script[src*="'+sectionCart+'.js"]')

        $s.updateDynamicContent(document.getElementById(sectionCart=='side_cart' ? 'side-cart' : 'cart'), data[sectionCart], '.cart-items');

        await $s.globalEval(addonsJs.outerHTML);
        await $s.globalEval(itemsManagementJs);

      }});

    }

    async function updateQuantity() {
      $s.showLoadingOverlay();
      var data = {updates: {}};
      data.updates[(self.dataset.key || self.dataset.id)] = self.update.value;
      await $s.updateCartItemsQuantity(data);
      updateUI();
    }

    self.remove.addEventListener('click', function() {
      self.update.value = 0;
      updateQuantity();
    });
    self.update.addEventListener('change', function() {
      updateQuantity();
    });
    self.add.addEventListener('click', function() {
      var fd = new FormData();
      this.closest('.add-form').querySelectorAll('[name]:checked,[name]:not([type="checkbox"]):not([type="radio"])').forEach(x=>fd.append(x.name, x.value));
      var promoConfig = window.__gwpPromotionsConfig && window.__gwpPromotionsConfig.promotions.find(function(p) {
        return p.id === self.settings.promoName;
      });
      var editOptions = gwpBuildSampleEditOptions(
        Array.from(self.variantSelector.querySelectorAll('option')),
        promoConfig,
        self.dataset.productId
      );
      fd.append('properties[_edit_options]', editOptions);
      fd.append('properties[_free_sample]', 'true');

      $s.showLoadingOverlay();
      self.util.postUpdate(
        routes.cart_url + '/add.js',
        fd
      ).then(function() {
        updateUI();
      });

    });    
  }

}
customElements.define('free-sample-card', ComponentFreeSampleCard);

// ─── New GWP Promotions System (metafield-based) ─────────────────────────────
// When window.__gwpPromotionsConfig is set (injected by gwp-config-bridge.liquid
// from the shop metafield), this replaces the legacy theme-settings-based promos.
//
// Cart attributes set on GWP items:
//   _gwp_promo_id  → promo UUID (read by discount function to apply discounts)
//   _locked        → "true" (prevents manual quantity editing in theme)

(function() {
  var config = window.__gwpPromotionsConfig;
  if (!config || !Array.isArray(config.promotions)) return;

  // ── Preview mode: read bridge-resolved preview param ──
  // The bridge persists ?gwp_preview= in sessionStorage + cart attributes so
  // preview mode survives normal store navigation after the URL param is gone.
  var previewParam = window.__gwpPreviewParam || (new URL(location.href)).searchParams.get('gwp_preview');
  var previewMode = null;
  if (previewParam) {
    previewParam = previewParam.trim();
    if (previewParam === 'all' || previewParam === 'true') {
      previewMode = { type: 'all' };
    } else if (previewParam.indexOf('only:') === 0) {
      var onlyIds = previewParam.slice(5).split(',').map(function(s) { return s.trim(); }).filter(Boolean);
      if (onlyIds.length > 0) previewMode = { type: 'only', ids: onlyIds };
    } else if (previewParam.indexOf('add:') === 0) {
      var addIds = previewParam.slice(4).split(',').map(function(s) { return s.trim(); }).filter(Boolean);
      if (addIds.length > 0) previewMode = { type: 'add', ids: addIds };
    } else {
      previewMode = { type: 'all' };
    }
  }
  window.__gwpPreviewMode = previewMode;

  // Stop any pre-existing rules before registering new ones
  var legacyRules = $s.AutoAddRemoveProducts.getRules();
  while (legacyRules.length > 0) {
    legacyRules[0].stop();
  }

  var util = $s.AutoAddRemoveProducts;

  var previewPromos = [];

  config.promotions.forEach(function(promo) {
    // ── Preview-aware status filtering ──
    if (previewMode && previewMode.type === 'only') {
      if (previewMode.ids.indexOf(promo.id) === -1) return;
      // "only:" bypasses status + dates
    } else if (previewMode && previewMode.type === 'add') {
      if (promo.status === 'disabled') return;
      if (promo.status === 'draft' && previewMode.ids.indexOf(promo.id) === -1) return;
    } else if (previewMode && previewMode.type === 'all') {
      if (promo.status === 'disabled') return;
    } else {
      if (promo.status !== 'live') return;
    }

    // In preview mode: collect for info panel; still fall through to create engine rules
    if (previewMode) {
      previewPromos.push(promo);
    }

    try {
      // ── Date/time filtering (skipped in preview so merchants can preview future/past promos) ──
      if (!previewMode) {
        var pageDT = window.pageDateTime || {};
        if (!gwpIsPromoActiveAtStoreDate(promo, pageDT.isoDate, pageDT.time)) return;
      }

      // ── Build conditions from promo config ──
      var conditions = [];

      (promo.conditions || []).forEach(function(cond) {
        var val = typeof cond.value === 'number' ? cond.value : parseFloat(cond.value) || 0;
        switch (cond.type) {
          case 'subtotal':
            // Admin UI stores dollars, engine expects dollars
            conditions.push(util.createConditionMinAmount(val));
            break;
          case 'quantity':
            conditions.push(util.createConditionMinQuantity(val));
            break;
          case 'discount_code':
            conditions.push(util.createConditionRequiredDiscountCode(String(cond.value)));
            break;
          case 'max_subtotal':
            conditions.push(util.createConditionMaxAmount(val));
            break;
          case 'product_in_cart':
            var requiredIds = String(cond.value).split(',').map(function(id) { return gwpExtractNumericId(id.trim()); }).filter(Boolean);
            conditions.push(util.createConditionCustom(function(cart) {
              if (requiredIds.length === 0) return true;
              var conditionItems = cart.__gwpConditionItems || cart.items;
              return conditionItems.some(function(item) {
                if (item.properties && item.properties._gwp_promo_id) return false; // skip GWP items
                return requiredIds.indexOf(item.id) !== -1 || requiredIds.indexOf(item.product_id) !== -1;
              });
            }));
            break;
          case 'tag':
          case 'required_tags': // alias — kept for backward compat
            // Supports comma-separated tags: "nike, adidas" → at least one product must have any of these tags
            conditions.push((function(tagsCsv) {
              var parsedTags = tagsCsv.split(',').map(function(t) { return t.trim(); }).filter(Boolean);
              return util.createConditionCustom(function(cart) {
                if (parsedTags.length === 0) return true;
                return cart.items.some(function(item) {
                  if (item.properties && item.properties._gwp_promo_id) return false;
                  var tags = item.product_tags || (window.__cartItemTags && window.__cartItemTags[item.id]) || [];
                  for (var t = 0; t < parsedTags.length; t++) {
                    if (tags.indexOf(parsedTags[t]) !== -1) return true;
                  }
                  return false;
                });
              });
            })(String(cond.value)));
            break;
          case 'customer_tag':
            conditions.push((function(tagValue) {
              var parsedCustomerTags = tagValue.split(',').map(function(t) { return t.trim(); }).filter(Boolean);
              return util.createConditionCustom(function() {
                var tags = window.__customerTags || [];
                if (parsedCustomerTags.length === 0) return true;
                return parsedCustomerTags.some(function(tag) { return tags.indexOf(tag) !== -1; });
              });
            })(String(cond.value)));
            break;
        }
      });

      // ── Cart filter (product-level filtering for condition evaluation) ──
      var cartFilterQueries = [];
      var cartItemsFilter = util.createCartFilter(cartFilterQueries);

      // ── Excluded product tags: exclude items with these tags from condition evaluation ──
      if (promo.excludedProductTags && promo.excludedProductTags.length > 0) {
        var excludedTags = promo.excludedProductTags;
        var originalCartFilter = cartItemsFilter;
        cartItemsFilter = function(cart, promoName) {
          var filtered = originalCartFilter.call(this, cart, promoName);
          filtered.items = filtered.items.filter(function(item) {
            // Always keep promo items (they need to be tracked)
            if (item.properties && item.properties._gwp_promo_id === promoName) return true;
            // Exclude items that have any of the excluded tags in their properties
            for (var t = 0; t < excludedTags.length; t++) {
              // Check product tags (from cart.js or Liquid-injected __cartItemTags mapping)
              var tags = item.product_tags || (window.__cartItemTags && window.__cartItemTags[item.id]) || [];
              if (tags.indexOf(excludedTags[t]) !== -1) return false;
            }
            return true;
          });
          return filtered;
        };
      }

      // ── Qualifying product tags: only items with these tags count toward subtotal/quantity ──
      if (promo.qualifyingProductTags && promo.qualifyingProductTags.length > 0) {
        cartItemsFilter = (function(prevFilter, qTags) {
          return function(cart, promoName) {
            var filtered = prevFilter.call(this, cart, promoName);
            filtered.items = filtered.items.filter(function(item) {
              if (item.properties && item.properties._gwp_promo_id === promoName) return true;
              var tags = item.product_tags || (window.__cartItemTags && window.__cartItemTags[item.id]) || [];
              for (var t = 0; t < qTags.length; t++) {
                if (tags.indexOf(qTags[t]) !== -1) return true;
              }
              return false;
            });
            return filtered;
          };
        })(cartItemsFilter, promo.qualifyingProductTags);
      }

      // ── Qualifying product IDs: only these products count toward subtotal/quantity ──
      if (promo.qualifyingProductIds && promo.qualifyingProductIds.length > 0) {
        cartItemsFilter = (function(prevFilter, qIds) {
          var numericIds = qIds.map(function(id) { return gwpExtractNumericId(id); });
          return function(cart, promoName) {
            var filtered = prevFilter.call(this, cart, promoName);
            filtered.items = filtered.items.filter(function(item) {
              if (item.properties && item.properties._gwp_promo_id === promoName) return true;
              return numericIds.indexOf(item.product_id) !== -1;
            });
            return filtered;
          };
        })(cartItemsFilter, promo.qualifyingProductIds);
      }

      // ── Required product tags: at least one non-GWP item must have one of these tags ──
      if (promo.requiredProductTags && promo.requiredProductTags.length > 0) {
        conditions.push((function(reqTags) {
          return util.createConditionCustom(function(cart) {
            return cart.items.some(function(item) {
              if (item.properties && item.properties._gwp_promo_id) return false;
              var tags = item.product_tags || (window.__cartItemTags && window.__cartItemTags[item.id]) || [];
              for (var t = 0; t < reqTags.length; t++) {
                if (tags.indexOf(reqTags[t]) !== -1) return true;
              }
              return false;
            });
          });
        })(promo.requiredProductTags));
      }

      // ── Build allowed products (GWP items) from promo config ──
      // For GWP promos, multiple variants with the same productId are variant options
      // for one gift, not separate auto-added gifts. Samples keep all variants because
      // customers choose them explicitly in the samples UI.
      var configuredGwpProducts = promo.gwpProducts || [];
      var allowedProducts = [];
      if (promo.type === 'samples') {
        allowedProducts = configuredGwpProducts.map(function(gp) {
          var variantId = gwpExtractNumericId(gp.variantId);
          var productId = gwpExtractNumericId(gp.productId);
          var item = {
            id: variantId,
            product_id: productId,
            quantity: gp.quantity || 1,
            maxQuantity: gp.quantity || 1,
            autoAdd: false,
            one_by_product: false,
            properties: {
              _gwp_promo_id: promo.id,
              _locked: 'true'
            }
          };
          if (gp.sellingPlanId) {
            item.selling_plan = gwpExtractNumericId(gp.sellingPlanId);
          }
          return item;
        });
      } else {
        var productGroups = {};
        configuredGwpProducts.forEach(function(gp) {
          var productId = gwpExtractNumericId(gp.productId);
          if (!productGroups[productId]) {
            productGroups[productId] = [];
          }
          productGroups[productId].push(gp);
        });
        allowedProducts = Object.keys(productGroups).map(function(productId) {
          var group = productGroups[productId];
          var defaultGp = group[0];
          var variantId = gwpExtractNumericId(defaultGp.variantId);
          var item = {
            id: variantId,
            product_id: productId,
            quantity: defaultGp.quantity || 1,
            maxQuantity: defaultGp.quantity || 1,
            autoAdd: true,
            one_by_product: true,
            variantIds: group.map(function(gp) { return gwpExtractNumericId(gp.variantId); }),
            properties: {
              _gwp_promo_id: promo.id,
              _locked: 'true'
            }
          };
          if (defaultGp.sellingPlanId) {
            item.selling_plan = gwpExtractNumericId(defaultGp.sellingPlanId);
          }
          return item;
        });
      }

      // ── Normalize maxUses (0 = unlimited, missing/invalid defaults to 1) ──
      var normalizedMaxUses = gwpNormalizeMaxUses(promo.maxUses);

      // ── Create rule using existing engine ──
      var settings = util.createSettings(promo.id, allowedProducts, true, normalizedMaxUses);
      var action = util.createActionAllowGWP();
      util.createRule(settings, conditions, action, cartItemsFilter);

    } catch (e) {
      console.error('[GWP] Rule creation failed for promo:', promo.id, e);
    }
  });

  // ── Preview Panel: persistent info panel in side cart ──
  if (previewPromos.length > 0) {
    window.__gwpPreviewPromos = previewPromos;

    function gwpEscapeHtml(value) {
      return String(value == null ? '' : value).replace(/[&<>"']/g, function(ch) {
        return ({
          '&': '&amp;',
          '<': '&lt;',
          '>': '&gt;',
          '"': '&quot;',
          "'": '&#39;'
        })[ch];
      });
    }

    // Build panel HTML from fresh cart data
    function gwpBuildPreviewHtml(cart) {
      var qualifyingPreviewItems = cart.items.filter(function(item) {
        return !(item.properties && (item.properties._gwp_promo_id || item.properties._free_sample));
      });
      var cartSubtotal = qualifyingPreviewItems.reduce(function(sum, item) {
        return sum + (item.final_line_price != null ? item.final_line_price : item.line_price || 0);
      }, 0) / 100;
      var cartQty = qualifyingPreviewItems.reduce(function(sum, item) { return sum + item.quantity; }, 0);
      var cartProductIds = qualifyingPreviewItems.map(function(item) { return item.product_id; });
      var cartTags = [];
      qualifyingPreviewItems.forEach(function(item) {
        var tags = window.__cartItemTags && window.__cartItemTags[item.variant_id];
        if (tags) cartTags = cartTags.concat(tags);
      });
      var customerTags = window.__customerTags || [];
      var discountCodes = getGwpDiscountCodes(cart).map(function(code) { return code.toUpperCase(); });

      var html = '<div class="gwp-preview-panel">';
      html += '<h2 class="gwp-preview-panel-title">Promo Preview</h2><p>Draft preview items are added without discounts. Live promos still discount normally.</p>';

      window.__gwpPreviewPromos.forEach(function(promo) {
        var conditionResults = [];
        var allMet = true;

        (promo.conditions || []).forEach(function(cond) {
          var met = false;
          var label = '';
          var val = typeof cond.value === 'number' ? cond.value : parseFloat(cond.value) || 0;

          switch (cond.type) {
            case 'subtotal':
              met = cartSubtotal >= val;
              label = 'Subtotal >= $' + val + ' (current: $' + cartSubtotal.toFixed(2) + ')';
              break;
            case 'max_subtotal':
              met = cartSubtotal < val;
              label = 'Subtotal < $' + val + ' (current: $' + cartSubtotal.toFixed(2) + ')';
              break;
            case 'quantity':
              met = cartQty >= val;
              label = 'Quantity >= ' + val + ' (current: ' + cartQty + ')';
              break;
            case 'product_in_cart':
              var targetIds = String(cond.value).split(',').map(function(id) { return gwpExtractNumericId(id.trim()); }).filter(Boolean);
              met = targetIds.length === 0 || targetIds.some(function(targetId) { return cartProductIds.indexOf(targetId) !== -1; });
              label = 'Product in cart: ' + (cond._productLabel || cond.value);
              break;
            case 'tag':
              var reqTags = String(cond.value).split(',').map(function(t) { return t.trim(); });
              met = reqTags.some(function(t) { return cartTags.indexOf(t) !== -1; });
              label = 'Product tag: ' + cond.value;
              break;
            case 'customer_tag':
              var reqCustomerTags = String(cond.value).split(',').map(function(t) { return t.trim(); }).filter(Boolean);
              met = reqCustomerTags.length === 0 || reqCustomerTags.some(function(t) { return customerTags.indexOf(t) !== -1; });
              label = 'Customer tag: ' + cond.value;
              break;
            case 'discount_code':
              met = discountCodes.indexOf(String(cond.value).toUpperCase()) !== -1;
              label = 'Discount code: ' + cond.value;
              break;
          }
          if (!met) allMet = false;
          conditionResults.push({ label: label, met: met });
        });

        var matchingRule = $s.AutoAddRemoveProducts.getRules().find(function(rule) {
          return rule.settings && rule.settings.promoName === promo.id;
        });
        var previewUses = allMet ? 1 : 0;
        var previewMaxUses = gwpNormalizeMaxUses(promo.maxUses);
        if (matchingRule) {
          try {
            var previewCart = JSON.parse(JSON.stringify(cart));
            allMet = matchingRule.run(previewCart);
            previewMaxUses = matchingRule.settings ? matchingRule.settings.maxUses : previewMaxUses;
            previewUses = allMet ? (previewCart.passedUses || 1) : 0;
          } catch (e) {
            console.error('[GWP Preview] Failed to evaluate promo eligibility:', promo.id, e);
          }
        }
        var previewUsesLimit = previewMaxUses === 0 ? 'no limit' : previewMaxUses;

        var statusClass = allMet ? 'gwp-preview-met' : 'gwp-preview-unmet';
        html += '<div class="gwp-preview-promo ' + statusClass + '">';
        html += '<div class="gwp-preview-promo-name">' + gwpEscapeHtml(promo.name) + ' <span class="gwp-preview-status">(' + gwpEscapeHtml(promo.status) + ')</span></div>';

        if (conditionResults.length > 0) {
          html += '<div class="gwp-preview-conditions-title">Requirements:</div><ul class="gwp-preview-conditions">';
          conditionResults.forEach(function(cr) {
            html += '<li class="' + (cr.met ? 'met' : 'unmet') + '">' + (cr.met ? '&#10003; ' : '&#10007; ') + gwpEscapeHtml(cr.label) + '</li>';
          });
          html += '</ul>';
        } else {
          html += '<div class="gwp-preview-conditions-title">No conditions (always active)</div>';
        }

        html += '<div class="gwp-preview-result">' + (allMet ? 'Eligible — discounts would be added when live' : 'Not eligible — conditions not met') + '</div>';
        html += '<div class="gwp-preview-meta"><span>Uses this order:</span> ' + gwpEscapeHtml(previewUses) + ' / ' + gwpEscapeHtml(previewUsesLimit) + '</div>';

        var previewProducts = promo.gwpProducts || [];
        if (previewProducts.length > 0) {
          var previewDiscount = previewProducts[0];
          var discountText = 'FREE';
          if (previewDiscount.discountType === 'percentage' && previewDiscount.discountValue < 100) discountText = previewDiscount.discountValue + '% off';
          else if (previewDiscount.discountType === 'fixed') discountText = '$' + (Number(previewDiscount.discountValue) || 0).toFixed(2) + ' off';
          html += '<div class="gwp-preview-discount"><span>Discount:</span> ' + gwpEscapeHtml(discountText) + '</div>';
        }

        html += '<div class="gwp-preview-products-title">' + (promo.type === 'samples' ? 'Sample Items' : 'GWP Items') + ':</div><div class="gwp-preview-products-scroll"><ol class="gwp-preview-products">';
        previewProducts.forEach(function(gp) {
          var name = gp.productTitle || gp.variantId || 'Unknown';
          if (gp.variantTitle && gp.variantTitle !== 'Default Title' && gp.variantTitle !== 'Default') {
            name += ' — ' + gp.variantTitle;
          }
          html += '<li>' + gwpEscapeHtml(name) + (gp.isSample ? ' (sample)' : '') + '</li>';
        });
        html += '</ol></div>';
        html += '</div>';
      });

      html += '<button class="btn btn-secondary gwp-preview-exit" onclick="window.__gwpExitPreview && window.__gwpExitPreview()">Exit Preview</button>';
      html += '</div>';
      return html;
    }

    window.__gwpExitPreview = function() {
      try {
        sessionStorage.removeItem('gwp-preview-mode');
        for (var i = sessionStorage.length - 1; i >= 0; i -= 1) {
          var key = sessionStorage.key(i);
          if (key && key.indexOf('gwp-preview-reloaded:') === 0) {
            sessionStorage.removeItem(key);
          }
        }
      } catch (error) {}

      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: { _gwp_preview: '' } })
      }).then(function() {
        var url = new URL(location.href);
        url.searchParams.delete('gwp_preview');
        location.href = url.pathname + url.search + url.hash;
      }).catch(function() {
        location.href = location.pathname;
      });
    };

    // Inject panel OUTSIDE [data-dynamic-content="sidecart"] so it survives cart re-renders
    function gwpInjectPreviewPanel() {
      fetch('/cart.js').then(function(r) { return r.json(); }).then(function(cart) {
        var html = gwpBuildPreviewHtml(cart);
        var existing = document.getElementById('gwp-preview-panel-container');

        if (existing) {
          // Panel already exists outside dynamic content — just update its innerHTML
          existing.innerHTML = html;
        } else {
          // First injection: place AFTER [data-dynamic-content="sidecart"] (outside dynamic zone)
          var dynamicContent = document.querySelector('[data-dynamic-content="sidecart"]');
          if (dynamicContent) {
            var panel = document.createElement('div');
            panel.id = 'gwp-preview-panel-container';
            panel.innerHTML = html;
            dynamicContent.parentNode.insertBefore(panel, dynamicContent.nextSibling);
          } else {
            // Fallback for cart page
            var cartItems = document.querySelector('.cart-items') || document.querySelector('form[action="/cart"]');
            if (cartItems) {
              var panel = document.createElement('div');
              panel.id = 'gwp-preview-panel-container';
              panel.innerHTML = html;
              cartItems.parentNode.insertBefore(panel, cartItems.nextSibling);
            }
          }
        }
      }).catch(function(e) {
        console.error('[GWP Preview] Failed to build preview panel:', e);
      });
    }

    // Expose for side_cart.liquid cart-addons to call after each runAllRules cycle
    window.__gwpInjectPreviewPanel = gwpInjectPreviewPanel;

    // Initial injection
    gwpInjectPreviewPanel();

    // Update panel when cart content changes.
    // loadSideCart() uses document.body.insertAdjacentHTML so #side-cart and
    // [data-dynamic-content="sidecart"] do NOT exist at script init time.
    // Observe document.body (always present). Mutations originating inside the
    // panel itself are skipped to prevent innerHTML-update feedback loops.
    var gwpPreviewDebounce = null;
    function gwpMutationLooksCartRelated(mutation) {
      if (mutation.target?.closest?.('#side-cart, #cart, .cart-items, [data-dynamic-content]')) return true;
      for (var n = 0; n < mutation.addedNodes.length; n++) {
        var node = mutation.addedNodes[n];
        if (node.nodeType === 1 && node.matches?.('#side-cart, #cart, .cart-items, [data-dynamic-content]')) return true;
      }
      return false;
    }

    new MutationObserver(function(mutations) {
      var panelEl = document.getElementById('gwp-preview-panel-container');
      for (var i = 0; i < mutations.length; i++) {
        var t = mutations[i].target;
        if (panelEl && (t === panelEl || panelEl.contains(t))) continue;
        if (!gwpMutationLooksCartRelated(mutations[i])) continue;
        clearTimeout(gwpPreviewDebounce);
        gwpPreviewDebounce = setTimeout(gwpInjectPreviewPanel, 300);
        break;
      }
    }).observe(document.body, { childList: true, subtree: true });
  }
})();

// Extract numeric ID from Shopify GID (e.g., "gid://shopify/ProductVariant/12345" → 12345)
function gwpExtractNumericId(gid) {
  if (!gid) return 0;
  if (typeof gid === 'number') return gid;
  var match = String(gid).match(/(\d+)$/);
  return match ? parseInt(match[1], 10) : 0;
}

// Normalize maxUses: 0 = unlimited, missing/invalid/fractional defaults to 1
function gwpNormalizeMaxUses(raw) {
  if (typeof raw === 'string') raw = parseInt(raw, 10);
  if (typeof raw !== 'number' || !Number.isFinite(raw) || raw < 0 || raw % 1 !== 0) return 1;
  return raw;
}

// Build sample _edit_options from selector options and promo config (pure helper for testability)
function gwpBuildSampleEditOptions(variantSelectorOptions, promoConfig, productId) {
  var configuredVariantIds = [];
  if (promoConfig && promoConfig.gwpProducts) {
    configuredVariantIds = promoConfig.gwpProducts
      .filter(function(gp) { return gwpExtractNumericId(gp.productId) == productId; })
      .map(function(gp) { return String(gwpExtractNumericId(gp.variantId)); });
  }
  var variantOptions = [];
  variantSelectorOptions.forEach(function(opt) {
    var optValue = (opt.value != null ? String(opt.value) : String(opt));
    if (configuredVariantIds.length === 0 || configuredVariantIds.indexOf(optValue) !== -1) {
      variantOptions.push('gid://shopify/ProductVariant/' + optValue);
    }
  });
  var editOptions = {r: true};
  if (variantOptions.length > 1) {
    editOptions.v = variantOptions;
  }
  return JSON.stringify(editOptions);
}

function gwpIsPromoActiveAtStoreDate(promo, storeDate, storeTime) {
  if (!promo || typeof promo !== 'object') return false;
  var hasSchedule = promo.startDate || promo.endDate || promo.startTime || promo.endTime;
  if (!hasSchedule) return true;
  var startDate = gwpDateOnly(promo.startDate);
  var endDate = gwpDateOnly(promo.endDate);
  var startTime = gwpTimeOnly(promo.startTime);
  var endTime = gwpTimeOnly(promo.endTime);
  if ((promo.startDate && !startDate) || (promo.endDate && !endDate) || (promo.startTime && (!startDate || !startTime)) || (promo.endTime && (!endDate || !endTime))) return false;
  if (startDate && endDate && startDate > endDate) return false;
  var currentDate = gwpDateOnly(storeDate || '');
  if (!currentDate) return false;

  var hasTimeBounds = !!(startTime || endTime);

  if (!hasTimeBounds) {
    if (startDate && currentDate < startDate) return false;
    if (endDate && currentDate > endDate) return false;
    return true;
  }

  var normalizedTime = gwpTimeOnly(storeTime);
  if (!normalizedTime) return false;

  var currentDateTime = currentDate + 'T' + normalizedTime;

  if (startDate) {
    var startDateTime = startDate + 'T' + (startTime || '00:00');
    if (currentDateTime < startDateTime) return false;
  }

  if (endDate) {
    var endDateTime = endDate + 'T' + (endTime || '23:59');
    if (currentDateTime > endDateTime) return false;
  }

  return true;
}

function gwpDateOnly(value) {
  if (!value) return '';
  var match = String(value).match(/^(\d{4})-(\d{2})-(\d{2})$/);
  if (!match) return '';
  var year = parseInt(match[1], 10);
  var month = parseInt(match[2], 10);
  var day = parseInt(match[3], 10);
  if (month < 1 || month > 12) return '';
  var daysInMonth = [31, (year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0)) ? 29 : 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
  if (day < 1 || day > daysInMonth[month - 1]) return '';
  return match[0];
}

function gwpTimeOnly(value) {
  if (!value) return '';
  var match = String(value).match(/^(?:[01]\d|2[0-3]):[0-5]\d$/);
  return match ? match[0] : '';
}

function gwpIsTierUnlocked(tier, thresholdCents) {
  if (tier && typeof tier.isQualified === 'boolean') return tier.isQualified;
  return tier.currentSubtotalCents >= thresholdCents;
}

function gwpPromoTierConditionsPass(promo, cart, useBefore) {
  var conditions = (promo && promo.conditions) || [];
  var requiresProof = !!(promo && (
    (promo.excludedProductTags && promo.excludedProductTags.length > 0) ||
    (promo.qualifyingProductTags && promo.qualifyingProductTags.length > 0) ||
    (promo.requiredProductTags && promo.requiredProductTags.length > 0) ||
    (promo.qualifyingProductIds && promo.qualifyingProductIds.length > 0) ||
    conditions.some(function(cond) {
      return cond.type !== 'subtotal' && cond.type !== 'max_subtotal';
    })
  ));

  if (!cart) return !requiresProof;

  var allNonGwpItems = (cart.items || []).filter(function(item) {
    return !(item.properties && item.properties._gwp_promo_id);
  });
  var scopedItems = allNonGwpItems.slice();

  if (promo && promo.excludedProductTags && promo.excludedProductTags.length > 0) {
    scopedItems = scopedItems.filter(function(item) {
      var tags = item.product_tags || (window.__cartItemTags && window.__cartItemTags[item.id]) || [];
      return !promo.excludedProductTags.some(function(tag) { return tags.indexOf(tag) !== -1; });
    });
  }

  if (promo && promo.qualifyingProductTags && promo.qualifyingProductTags.length > 0) {
    scopedItems = scopedItems.filter(function(item) {
      var tags = item.product_tags || (window.__cartItemTags && window.__cartItemTags[item.id]) || [];
      return promo.qualifyingProductTags.some(function(tag) { return tags.indexOf(tag) !== -1; });
    });
  }

  if (promo && promo.qualifyingProductIds && promo.qualifyingProductIds.length > 0) {
    var qualifyingIds = promo.qualifyingProductIds.map(function(id) { return gwpExtractNumericId(id); });
    scopedItems = scopedItems.filter(function(item) {
      return qualifyingIds.indexOf(item.product_id) !== -1;
    });
  }

  var subtotalCents = scopedItems.reduce(function(sum, item) {
    var amount = useBefore
      ? (item.original_line_price != null ? item.original_line_price : (item.line_price || item.final_line_price || 0))
      : (item.final_line_price != null ? item.final_line_price : (item.line_price || 0));
    return sum + amount;
  }, 0);

  var quantity = scopedItems.reduce(function(sum, item) {
    return sum + (item.quantity || 0);
  }, 0);

  var customerTags = window.__customerTags || [];

  var requiredTagsPassed = !promo || !promo.requiredProductTags || promo.requiredProductTags.length === 0 || scopedItems.some(function(item) {
    var tags = item.product_tags || (window.__cartItemTags && window.__cartItemTags[item.id]) || [];
    return promo.requiredProductTags.some(function(tag) { return tags.indexOf(tag) !== -1; });
  });

  return (promo && conditions.every(function(cond) {
    var val = typeof cond.value === 'number' ? cond.value : parseFloat(cond.value) || 0;
    switch (cond.type) {
      case 'subtotal':
        return true;
      case 'quantity':
        return quantity >= val;
      case 'discount_code':
        return getGwpDiscountCodes(cart).indexOf(String(cond.value).toLowerCase()) !== -1;
      case 'max_subtotal': {
        var maxThresholdCents = gwpResolvePresentmentThresholdCents(val);
        if (maxThresholdCents === null) {
          cart.__gwpMonetaryContextUnresolved = true;
          return false;
        }
        return subtotalCents < maxThresholdCents;
      }
      case 'product_in_cart': {
        var requiredIds = String(cond.value).split(',').map(function(id) { return gwpExtractNumericId(id.trim()); }).filter(Boolean);
        if (requiredIds.length === 0) return true;
        return allNonGwpItems.some(function(item) {
          return requiredIds.indexOf(item.id) !== -1 || requiredIds.indexOf(item.product_id) !== -1;
        });
      }
      case 'tag':
      case 'required_tags': {
        var parsedTags = String(cond.value).split(',').map(function(t) { return t.trim(); }).filter(Boolean);
        if (parsedTags.length === 0) return true;
        return scopedItems.some(function(item) {
          var tags = item.product_tags || (window.__cartItemTags && window.__cartItemTags[item.id]) || [];
          return parsedTags.some(function(tag) { return tags.indexOf(tag) !== -1; });
        });
      }
      case 'customer_tag': {
        var parsedCustomerTags = String(cond.value).split(',').map(function(t) { return t.trim(); }).filter(Boolean);
        if (parsedCustomerTags.length === 0) return true;
        return parsedCustomerTags.some(function(tag) { return customerTags.indexOf(tag) !== -1; });
      }
      default:
        return true;
    }
  }) && requiredTagsPassed);
}

function gwpCollectManualTiers(promotions) {
  var tiers = [];
  (promotions || []).forEach(function(promo) {
    (promo.manualTiers || []).forEach(function(manualTier) {
      tiers.push(manualTier);
    });
  });
  return tiers;
}

// GWP thresholds are configured in shop currency. Convert once to an integer
// presentment minor unit using half-up rounding before any entitlement comparison.
function gwpResolvePresentmentThresholdCents(baseAmount) {
  var rate = Number(window.__gwpPresentmentCurrencyRate);
  var amount = Number(baseAmount);
  if (!Number.isFinite(rate) || rate <= 0 || !Number.isFinite(amount) || amount < 0) return null;
  var baseMinorUnits = Math.round((amount * 100) + Number.EPSILON);
  return Math.round((baseMinorUnits * rate) + Number.EPSILON);
}

function gwpGetTierThresholdCents(tier) {
  if (tier && Number.isSafeInteger(tier.thresholdCents) && tier.thresholdCents >= 0) {
    return tier.thresholdCents;
  }
  return gwpResolvePresentmentThresholdCents(tier && tier.threshold);
}

// Build tier thresholds from promotions config (pure helper for testability)
function gwpBuildTierThresholds(promotions, pvMode, storeDate, storeTime, cart, computeSubtotal, useBefore, cartTotal, isTierQualifiedFn, manualTiers) {
  var allTiers = [];
  var globalManualTiers = Array.isArray(manualTiers) ? manualTiers : gwpCollectManualTiers(promotions);

  globalManualTiers.forEach(function(manualTier) {
    var minAmount = typeof manualTier.minAmount === 'number' ? manualTier.minAmount : parseFloat(manualTier.minAmount);
    if (!Number.isFinite(minAmount) || minAmount < 0) return;
    var thresholdCents = gwpResolvePresentmentThresholdCents(minAmount);
    if (thresholdCents === null) return;
    allTiers.push({
      threshold: minAmount,
      thresholdCents: thresholdCents,
      currentSubtotalCents: cartTotal,
      isQualified: cartTotal >= thresholdCents,
      label: manualTier.lockedLabel,
      unlockedLabel: manualTier.unlockedLabel
    });
  });

  promotions.forEach(function(promo) {
    if (pvMode && pvMode.type === 'only') {
      if (pvMode.ids.indexOf(promo.id) === -1) return;
    } else if (pvMode && pvMode.type === 'add') {
      if (promo.status === 'disabled') return;
      if (promo.status === 'draft' && pvMode.ids.indexOf(promo.id) === -1) return;
    } else if (pvMode && pvMode.type === 'all') {
      if (promo.status === 'disabled') return;
    } else {
      if (promo.status !== 'live') return;
    }
    if (!pvMode) {
      if (!gwpIsPromoActiveAtStoreDate(promo, storeDate, storeTime)) return;
    }
    var subtotalCond = (promo.conditions || []).find(function(c) { return c.type === 'subtotal'; });
    if (!subtotalCond || typeof subtotalCond.value !== 'number' || subtotalCond.value <= 0) return;
    var baseThreshold = subtotalCond.value;
    var baseThresholdCents = gwpResolvePresentmentThresholdCents(baseThreshold);
    if (baseThresholdCents === null) return;
    var maxUses = promo.maxUses;
    if (typeof maxUses === 'string') maxUses = parseInt(maxUses, 10);
    if (typeof maxUses !== 'number' || !Number.isFinite(maxUses) || maxUses < 0) maxUses = 1;
    var displayCount = Math.min(maxUses > 1 ? maxUses : 1, 8);
    var promoIsQualified = typeof isTierQualifiedFn === 'function' ? !!isTierQualifiedFn(promo, cart, storeDate, storeTime, useBefore) : true;
    var currentSubtotalCents = cart ? computeSubtotal(cart, promo, useBefore) : cartTotal;
    for (var i = 1; i <= displayCount; i++) {
      var threshold = baseThreshold * i;
      var thresholdCents = baseThresholdCents * i;
      allTiers.push({
        threshold: threshold,
        thresholdCents: thresholdCents,
        currentSubtotalCents: currentSubtotalCents,
        isQualified: currentSubtotalCents >= thresholdCents && promoIsQualified,
        label: promo.tierLabel || ('Spend {remaining} more for ' + promo.name),
        unlockedLabel: promo.tierUnlockedLabel || (promo.name + ' unlocked!')
      });
    }
  });
  allTiers.sort(function(a, b) { return a.thresholdCents - b.thresholdCents; });
  return allTiers.slice(0, 8);
}

function gwpEscapeTierLabelHtml(value) {
  return String(value == null ? '' : value)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}

function gwpStripLeadingTierNumber(label) {
  return String(label == null ? '' : label).replace(/^\d+[\s.):-]*\s+/, '');
}

function gwpBuildTierGroupLabelHtml(group, thresholdCents, stripLeadingNumber) {
  return group.items.map(function(tier) {
    var isUnlocked = gwpIsTierUnlocked(tier, thresholdCents);
    var remaining = thresholdCents - tier.currentSubtotalCents;
    var remainingFormatted = $s.formatMoney(Math.max(0, remaining)).replace('.00', '');
    var label = isUnlocked
      ? tier.unlockedLabel
      : tier.label.replace('{remaining}', remainingFormatted);
    if (stripLeadingNumber) {
      label = gwpStripLeadingTierNumber(label);
    }
    return '<span class="gwp-tiered-label-text' + (isUnlocked ? ' unlocked' : '') + '">' + gwpEscapeTierLabelHtml(label) + '</span>';
  }).join(' <strong>+</strong> ');
}

function gwpBuildSingleTierLabelHtml(tier, thresholdCents) {
  var remaining = thresholdCents - tier.currentSubtotalCents;
  var remainingFormatted = $s.formatMoney(Math.max(0, remaining)).replace('.00', '');
  var label = gwpIsTierUnlocked(tier, thresholdCents)
    ? tier.unlockedLabel
    : tier.label.replace('{remaining}', remainingFormatted);
  return gwpEscapeTierLabelHtml(label);
}

function gwpBuildTierNextMessageHtml(allTiers, completionMessage, nextTierMessageTemplate) {
  var nextTier = allTiers.find(function(tier) {
    var thresholdCents = gwpGetTierThresholdCents(tier);
    return !gwpIsTierUnlocked(tier, thresholdCents);
  });

  if (!nextTier) {
    return gwpEscapeTierLabelHtml(completionMessage || 'All tiers have been unlocked!');
  }

  var thresholdCents = gwpGetTierThresholdCents(nextTier);
  var remaining = thresholdCents - nextTier.currentSubtotalCents;
  var remainingFormatted = $s.formatMoney(Math.max(0, remaining)).replace('.00', '');
  var template = String(nextTierMessageTemplate || 'Spend  to unlock next tier!');
  var escapedAmount = gwpEscapeTierLabelHtml(remainingFormatted);
  var amountHtml = '<strong class="gwp-tiered-next-amount">' + escapedAmount + '</strong>';
  var templateParts = template.split(/\{\{\s*amount\s*\}\}/g);

  if (templateParts.length === 1) {
    return gwpEscapeTierLabelHtml(template);
  }

  return templateParts.map(function(part) {
    return gwpEscapeTierLabelHtml(part);
  }).join(amountHtml);
}

function gwpBuildTierProgressFillPercent(allTiers, groupedTiers, maxThresholdCents, layout) {
  if (layout !== 'even') {
    return gwpBuildTierProgressPercent(allTiers, maxThresholdCents);
  }

  if (!groupedTiers || groupedTiers.length === 0) return 0;

  var thresholds = groupedTiers.map(function(group) {
    return gwpGetTierThresholdCents(group);
  });
  var groupTiers = function(group) {
    if (Array.isArray(group.items) && group.items.length > 0) return group.items;
    return allTiers.filter(function(tier) {
      return tier.threshold === group.threshold;
    });
  };
  var isTierReached = function(tier, thresholdCents) {
    return typeof tier.isQualified === 'boolean' ? tier.isQualified : tier.currentSubtotalCents >= thresholdCents;
  };
  var controllingIndex = -1;
  var currentSubtotalCents = 0;

  for (var i = 0; i < groupedTiers.length; i++) {
    var thresholdCents = thresholds[i];
    var tiers = groupTiers(groupedTiers[i]);
    if (tiers.length === 0 || !tiers.some(function(tier) { return isTierReached(tier, thresholdCents); })) {
      controllingIndex = i;
      currentSubtotalCents = tiers.reduce(function(max, tier) {
        return Math.max(max, tier.currentSubtotalCents || 0);
      }, 0);
      if (currentSubtotalCents >= thresholdCents && tiers.some(function(tier) { return typeof tier.isQualified === 'boolean'; })) {
        return groupedTiers.length > 1
          ? (Math.max(0, controllingIndex - 1) / (thresholds.length - 1)) * 100
          : 0;
      }
      break;
    }
  }

  if (controllingIndex === -1) return 100;

  if (thresholds.length === 1) {
    return thresholds[0] > 0 ? Math.min(100, Math.max(0, currentSubtotalCents / thresholds[0] * 100)) : 0;
  }

  if (currentSubtotalCents <= thresholds[0]) return 0;
  if (currentSubtotalCents >= thresholds[thresholds.length - 1]) return 100;

  for (var i = 0; i < thresholds.length - 1; i++) {
    var lower = thresholds[i];
    var upper = thresholds[i + 1];
    if (currentSubtotalCents === lower) {
      return (i / (thresholds.length - 1)) * 100;
    }
    if (currentSubtotalCents < upper) {
      var fraction = (currentSubtotalCents - lower) / (upper - lower);
      return ((i + fraction) / (thresholds.length - 1)) * 100;
    }
  }

  return 100;
}

function gwpBuildTierLabelsHtml(groupedTiers, tierPositions, labelLayout) {
  if (labelLayout === 'list') {
    var listHtml = '<ul class="gwp-tiered-labels-list">';
    groupedTiers.forEach(function(group, i) {
      var thresholdCents = gwpGetTierThresholdCents(group);
      var isUnlocked = group.items.some(function(tier) { return gwpIsTierUnlocked(tier, thresholdCents); });
      listHtml += '<li class="gwp-tiered-label-item">';
      listHtml += '<span class="gwp-tiered-circle-badge' + (isUnlocked ? ' unlocked' : '') + '"></span>';
      listHtml += '<span>' + gwpBuildTierGroupLabelHtml(group, thresholdCents) + '</span>';
      listHtml += '</li>';
    });
    return listHtml + '</ul>';
  }

  var underMarkersHtml = '<div class="gwp-tiered-labels-under-markers">';
  groupedTiers.forEach(function(group, i) {
    var thresholdCents = gwpGetTierThresholdCents(group);
    var isUnlocked = group.items.some(function(tier) { return gwpIsTierUnlocked(tier, thresholdCents); });
    underMarkersHtml += '<span class="gwp-tiered-label-item" style="left:' + tierPositions[i] + '%">';
    underMarkersHtml += '<span class="gwp-tiered-circle-badge' + (isUnlocked ? ' unlocked' : '') + '"></span>';
    underMarkersHtml += '<span>' + gwpBuildTierGroupLabelHtml(group, thresholdCents, true) + '</span>';
    underMarkersHtml += '</span>';
  });
  return underMarkersHtml + '</div>';
}

function gwpBuildTierPositionPercentages(groups, maxThresholdCents, minGapPercent, layout) {
  if (layout === 'even') {
    if (groups.length <= 1) return groups.map(function() { return 0; });
    var evenStep = 100 / (groups.length - 1);
    return groups.map(function(_, index) { return index * evenStep; });
  }

  var gap = minGapPercent == null ? 10 : minGapPercent;
  var positions = groups.map(function(group) {
    var thresholdCents = gwpGetTierThresholdCents(group);
    var pos = maxThresholdCents > 0 ? (thresholdCents / maxThresholdCents) * 100 : 0;
    return Math.max(0, Math.min(100, pos));
  });

  for (var i = 1; i < positions.length; i++) {
    if (positions[i] - positions[i - 1] < gap) {
      positions[i] = positions[i - 1] + gap;
    }
  }

  var overflow = positions.length ? positions[positions.length - 1] - 100 : 0;
  if (overflow > 0) {
    positions = positions.map(function(pos) { return pos - overflow; });
    if (positions[0] < 0) {
      var step = positions.length > 1 ? 100 / (positions.length - 1) : 0;
      positions = positions.map(function(_, index) { return step * index; });
    }
  }

  return positions.map(function(pos) {
    return Math.max(0, Math.min(100, pos));
  });
}

function gwpBuildTierProgressPercent(allTiers, maxThresholdCents) {
  var progressCents = Math.max.apply(null, allTiers.map(function(tier) {
    var thresholdCents = gwpGetTierThresholdCents(tier);
    return Math.min(tier.currentSubtotalCents, thresholdCents);
  }));
  return maxThresholdCents > 0 ? Math.min(100, progressCents / maxThresholdCents * 100) : 0;
}

function gwpComputeTierSubtotalCents(cart, promo, useBefore) {
  var items = (cart.items || []).filter(function(item) {
    return !(item.properties && item.properties._gwp_promo_id);
  });

  if (promo && promo.excludedProductTags && promo.excludedProductTags.length > 0) {
    items = items.filter(function(item) {
      var tags = item.product_tags;
      if (!Array.isArray(tags) && window.__cartItemTags) tags = window.__cartItemTags[item.id];
      if (!Array.isArray(tags)) return false;
      return !promo.excludedProductTags.some(function(tag) { return tags.indexOf(tag) !== -1; });
    });
  }

  if (promo && promo.qualifyingProductTags && promo.qualifyingProductTags.length > 0) {
    items = items.filter(function(item) {
      var tags = item.product_tags || (window.__cartItemTags && window.__cartItemTags[item.id]) || [];
      return promo.qualifyingProductTags.some(function(tag) { return tags.indexOf(tag) !== -1; });
    });
  }

  if (promo && promo.qualifyingProductIds && promo.qualifyingProductIds.length > 0) {
    var qualifyingIds = promo.qualifyingProductIds.map(function(id) { return gwpExtractNumericId(id); });
    items = items.filter(function(item) {
      return qualifyingIds.indexOf(item.product_id) !== -1;
    });
  }

  return items.reduce(function(sum, item) {
    var amount = useBefore
      ? (item.original_line_price != null ? item.original_line_price : (item.line_price || item.final_line_price || 0))
      : (item.final_line_price != null ? item.final_line_price : (item.line_price || 0));
    return sum + amount;
  }, 0);
}


function gwpNormalizeConfiguredId(value, prefix) {
  try {
    var normalized = String(value || '');
    return normalized.indexOf(prefix) === 0 ? normalized.slice(prefix.length) : normalized;
  } catch (error) {
    return '';
  }
}

function gwpResolveCartItemDiscountLabel(config, promoId, variantId, productId) {
  if (!config || !Array.isArray(config.promotions) || !promoId) return '';
  var promo = config.promotions.find(function(candidate) {
    return candidate && typeof candidate === 'object' && gwpNormalizeConfiguredId(candidate.id, '') === gwpNormalizeConfiguredId(promoId, '');
  });
  if (!promo || gwpNormalizeConfiguredId(promo.status, '').toLowerCase() !== 'live' || typeof promo.discountLabel !== 'string' || !promo.discountLabel.trim() || !Array.isArray(promo.gwpProducts)) return '';
  var pageDT = window.pageDateTime || {};
  try {
    if (!gwpIsPromoActiveAtStoreDate(promo, window.__gwpStoreDate || pageDT.isoDate, window.__gwpStoreTime || pageDT.time)) return '';
  } catch (error) {
    return '';
  }

  var itemVariantId = gwpNormalizeConfiguredId(variantId, '');
  var itemProductId = gwpNormalizeConfiguredId(productId, '');
  var configuredItem = promo.gwpProducts.some(function(product) {
    if (!product || typeof product !== 'object') return false;
    var configuredVariantId = gwpNormalizeConfiguredId(product.variantId, 'gid://shopify/ProductVariant/');
    var configuredProductId = gwpNormalizeConfiguredId(product.productId, 'gid://shopify/Product/');
    return configuredVariantId
      ? configuredVariantId === itemVariantId
      : configuredProductId === itemProductId;
  });

  return configuredItem ? promo.discountLabel : '';
}

if (!customElements.get('gwp-discount-label')) {
class GwpDiscountLabel extends HTMLElement {
  connectedCallback() {
    this.render();
  }

  render() {
    var label = gwpResolveCartItemDiscountLabel(
      window.__gwpPromotionsConfig,
      this.dataset.promoId,
      this.dataset.variantId,
      this.dataset.productId
    );
    if (label) this.textContent = label;
    else if (!this.textContent.trim()) this.remove();
  }
}
customElements.define('gwp-discount-label', GwpDiscountLabel);
}


// ─── Tiered Progress Bar Custom Element ──────────────────────────────────────
// Stepped progress bar with numbered circles at each tier threshold.
// Single tier: simple bar with goal at the end.
// Multi-tier: proportionally positioned circles with amounts above, labels below.

class GwpTieredProgress extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.render();
  }

  async render() {
    var config = window.__gwpPromotionsConfig;
    if (!config || !Array.isArray(config.promotions)) { this.classList.remove('gwp-tiered-progress-under-markers', 'marker-spacing-even', 'marker-spacing-proportional'); this.style.display = 'none'; return; }
    if (!config.tieredProgressBar) { this.classList.remove('gwp-tiered-progress-under-markers', 'marker-spacing-even', 'marker-spacing-proportional'); this.style.display = 'none'; return; }
    this.style.display = '';

    var useBefore = config.compareAmountMode === 'before';
    var cart = await this.getCart();
    var cartTotal = cart
      ? this.computeSubtotalCents(cart, null, useBefore)
      : (parseInt(useBefore ? this.dataset.cartTotalBefore : this.dataset.cartTotal) || 0); // cents in customer currency
    var pageDT = window.pageDateTime || {};
    var storeDate = pageDT.isoDate || null;
    var storeTime = pageDT.time || null;
    var manualTiers = Array.isArray(config.manualTiers) ? config.manualTiers : gwpCollectManualTiers(config.promotions);
    var self = this;

    // Build global tiers from subtotal conditions of active promos
    var allTiers = gwpBuildTierThresholds(
      config.promotions,
      window.__gwpPreviewMode,
      storeDate,
      storeTime,
      cart,
      function(c, p, u) { return self.computeSubtotalCents(c, p, u); },
      useBefore,
      cartTotal,
      function(promo, currentCart) { return gwpPromoTierConditionsPass(promo, currentCart, useBefore); },
      manualTiers
    );

    if (allTiers.length === 0) { this.classList.remove('gwp-tiered-progress-under-markers', 'marker-spacing-even', 'marker-spacing-proportional'); this.style.display = 'none'; return; }

    var maxThresholdCents = gwpGetTierThresholdCents(allTiers[allTiers.length - 1]);
    if (maxThresholdCents === null) { this.style.display = 'none'; return; }
    var labelLayout = config.tierLabelLayout === 'list' ? 'list' : 'underMarkers';
    this.classList.toggle('gwp-tiered-progress-under-markers', labelLayout === 'underMarkers' && allTiers.length > 1);
    var markerLayout = config.tierMarkerLayout === 'even' ? 'even' : 'proportional';
    this.classList.toggle('marker-spacing-even', markerLayout === 'even');
    this.classList.toggle('marker-spacing-proportional', markerLayout === 'proportional');
    var html = '';

    if (allTiers.length === 1) {
      // ── Single tier: simple bar (like free-shipping-progress) ──
      var tier = allTiers[0];
      var thresholdCents = gwpGetTierThresholdCents(tier);
      var currentSubtotalCents = tier.currentSubtotalCents;
      var progress = thresholdCents > 0 ? Math.min(100, currentSubtotalCents / thresholdCents * 100) : 0;

      html += '<div class="gwp-tiered-single">';
      html += '<div class="gwp-tiered-single-label">';
      html += gwpBuildSingleTierLabelHtml(tier, thresholdCents);
      html += '</div>';
      html += '<div class="gwp-tiered-track">';
      html += '<div class="gwp-tiered-track-fill ease-animation-slow" style="width: 0%" data-target-width="' + progress + '"></div>';
      html += '</div>';
      html += '<div class="gwp-tiered-single-goal">' + $s.formatMoney(thresholdCents).replace('.00', '') + '</div>';
      html += '</div>';
    } else {
      // ── Multi-tier: stepped circles with proportional positioning ──
      // Group tiers by threshold — merge duplicates into one circle on the track
      var groupedTiers = [];
      allTiers.forEach(function(tier) {
        var existing = groupedTiers.find(function(g) { return g.thresholdCents === tier.thresholdCents; });
        if (existing) {
          existing.items.push(tier);
        } else {
          groupedTiers.push({ threshold: tier.threshold, thresholdCents: tier.thresholdCents, items: [tier] });
        }
      });

      var tierPositions = gwpBuildTierPositionPercentages(groupedTiers, maxThresholdCents, 10, markerLayout);
      var totalProgress = gwpBuildTierProgressFillPercent(allTiers, groupedTiers, maxThresholdCents, markerLayout);
      var barGroupClass = 'gwp-tiered-bar-group' + (labelLayout === 'underMarkers' ? ' gwp-tiered-bar-group-under-markers' : '');

      html += '<div class="' + barGroupClass + '">';

      // Amounts row (above track) — one per group, proportionally positioned
      html += '<div class="gwp-tiered-amounts" style="position:relative;height:1.4em;">';
      groupedTiers.forEach(function(group, i) {
        var thresholdCents = gwpGetTierThresholdCents(group);
        var pos = tierPositions[i];
        html += '<span class="gwp-tiered-amount" style="left:' + pos + '%">';
        html += $s.formatMoney(thresholdCents).replace('.00', '');
        html += '</span>';
      });
      html += '</div>';

      // Track with circles — one per group, proportionally positioned
      html += '<div class="gwp-tiered-track">';
      html += '<div class="gwp-tiered-track-fill ease-animation-slow" style="width: 0%" data-target-width="' + totalProgress + '"></div>';
      groupedTiers.forEach(function(group, i) {
        var thresholdCents = gwpGetTierThresholdCents(group);
        var isUnlocked = group.items.some(function(tier) { return gwpIsTierUnlocked(tier, thresholdCents); });
        var pos = tierPositions[i];
        html += '<span class="gwp-tiered-circle' + (isUnlocked ? ' unlocked' : '') + '" style="left:' + pos + '%"></span>';
      });
      html += '</div>';

      // Labels below the track: either a compact under-marker row or a list layout.
      html += gwpBuildTierLabelsHtml(groupedTiers, tierPositions, labelLayout);

      html += '</div>';

      html += '<div class="gwp-tiered-next-message">' + gwpBuildTierNextMessageHtml(allTiers, config.completionMessage, config.nextTierMessageTemplate) + '</div>';
    }

    this.innerHTML = html;

    // Animate progress bar fill
    setTimeout(function() {
      var bar = self.querySelector('.gwp-tiered-track-fill[data-target-width]');
      if (bar) bar.style.width = bar.dataset.targetWidth + '%';
    });
  }

  async getCart() {
    try {
      var response = await fetch('/cart.js');
      var cart = await response.json();
      if ($s.refreshCartItemTags) await $s.refreshCartItemTags(cart);
      return cart;
    } catch (e) {
      return null;
    }
  }

  computeSubtotalCents(cart, promo, useBefore) {
    return gwpComputeTierSubtotalCents(cart, promo, useBefore);
  }
}
customElements.define('gwp-tiered-progress', GwpTieredProgress);

